import React from "react";
import "./App.css";
import { BrowserRouter as Router, Switch, Route, Redirect, withRouter } from "react-router-dom";
import { ServicesProvider, AuthProvider, UserProvider, EventsProvider, ReportProvider, UsersProvider, BillingProvider, ProductUpdatesProvider } from "./contexts";
import { Login, Home, Arbs, Register, Check, UserHome, ActivateAccount, Extension, Events, UserBets, UserBookies, AddBookie, AcademyHome, AvailableBookies, Terms, Valuebets, Pricing, Administrators, ProductUpdates, Settings } from "./components";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './styles/toast.css';

const App = () => {
  return (
    <Router>
      <ServicesProvider>
        <AuthProvider>
          <UserProvider>
            <EventsProvider>
              <ReportProvider>
                <UsersProvider>
                  <BillingProvider>
                    <ProductUpdatesProvider>
                      <Switch>
                        <Route path="/" exact component={withRouter(Home)} />
                        <Route path="/login" exact component={withRouter(Login)} />
                        <Route path="/home" exact component={withRouter(Home)} />
                        <Route path="/home/logged" exact component={withRouter(UserHome)} />
                        <Route path="/arbs/live" component={withRouter(Arbs)} />
                        <Route path="/arbs/bookies" component={withRouter(AvailableBookies)} />
                        <Route path="/pricing" component={withRouter(Pricing)} />
                        <Route path="/arbs" component={withRouter(Arbs)} />
                        <Route path="/valuebets" component={withRouter(Valuebets)} />
                        <Route path="/register" component={withRouter(Register)} />
                        <Route path="/extension" component={withRouter(Extension)} />
                        <Route path="/events" component={withRouter(Events)} />
                        <Route path="/login" component={withRouter(Login)} />
                        <Route path="/check" component={withRouter(Check)} />
                        <Route path="/activateaccount" exact component={withRouter(ActivateAccount)} />
                        <Route path="/:email/bets" component={withRouter(UserBets)} />
                        <Route exact path="/bookies/:email" component={withRouter(UserBookies)}/>
                        <Route exact path="/bookies/:email/:bookie/:action" component={withRouter(AddBookie)} />
                        <Route exact path="/academy" component={withRouter(AcademyHome)} />
                        <Route exact path="/terms" component={withRouter(Terms)} />
                        <Route exact path="/administrators" component={withRouter(Administrators)} />
                        <Route exact path="/changelog" component={withRouter(ProductUpdates)} />
                        <Route exact path="/settings" component={withRouter(Settings)} />
                        <Route render={() => <Redirect to="/" />} />
                      </Switch>
                      <ToastContainer
                        position="top-right"
                        autoClose={3000}
                        hideProgressBar={false}
                        newestOnTop
                        closeOnClick
                        rtl={false}
                        pauseOnFocusLoss
                        draggable
                        pauseOnHover
                        theme="colored"
                      />
                    </ProductUpdatesProvider>
                  </BillingProvider>
                </UsersProvider>
              </ReportProvider>
            </EventsProvider>
          </UserProvider>
        </AuthProvider>
      </ServicesProvider>
    </Router>
  );
};

export default App;
